import React from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import styles from "./privacy.module.scss";

const mapStateToProps = (state) => ({
  tenant: state.getIn(["tenantReducer", "tenant"]),
});

const sdkList = [
  {
    name: "Bugly Android",
    developer: "深圳市腾讯计算机系统有限公司",
    purpose: "崩溃日志收集与分析",
    policyUrl: "https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56",
    permissions: "安卓系统需要使用 android.permission.INTERNET 和 android.permission.ACCESS_NETWORK_STATE 权限，用于查看网络状态，进行数据上报，实现开发者查看崩溃信息的目的。这些权限会在进程启动阶段及Crash闪退时调用，用于上传日志，属于必选权限。iOS系统需要网络权限，同样用于查看网络状态、数据上报和开发者查看崩溃信息，在进程启动阶段及Crash闪退时调用，属于必选权限。",
  },
  {
    name: "人脸离线识别SDK（Face_SDK）",
    developer: "北京百度网讯科技有限公司",
    purpose: "人脸识别验证",
    policyUrl: "https://ai.baidu.com/ai-doc/REFERENCE/Akdyizf5t",
    permissions: "设备信息（操作系统信息）、IP地址（用于生成设备硬件指纹Device ID，实现SDK联网激活）、图片信息（用于进行人脸识别）。使用的设备权限包括：拍摄权限（用于采集人脸图片，仅在本地完成识别，不与云端交互）、读取电话状态权限（用于获取设备IMSI/IMEI，生成设备ID进行本地SDK鉴权）、读取/写入外部存储卡权限（用于存储人脸图片或特征值信息，仅在本地完成识别）。这些权限需要用户授权才能开启，用户可以随时在系统中取消授权，但可能导致部分功能无法正常使用。",
  },
  {
    name: "人脸离线采集SDK",
    developer: "北京百度网讯科技有限公司",
    purpose: "人脸图像采集和活体验证",
    policyUrl: "https://ai.baidu.com/ai-doc/REFERENCE/Ckdym0tc9",
    permissions: "人脸离线采集SDK用于实现人脸图像采集和活体验证功能，需要收集以下个人信息：设备信息(包括设备型号、操作系统信息)、IP地址(用于生成设备硬件指纹Device ID，实现SDK联网激活)、图片信息和视频信息(用于进行人脸识别和活体验证)。使用的设备权限包括：相机权限(用于采集人脸图片和视频，仅在本地完成识别)、麦克风权限(用于视频录制时的音频采集)、读取/写入外部存储卡权限(用于存储人脸图片或特征值信息)、网络访问权限(用于数据传输和活体核验)、位置权限(通过IP地址获取粗略位置用于检验设备环境)。所有人脸图像和视频信息将加密存储在本地，不上传至云端(除非开发者另有配置)。",
  },
  {
    name: "对象存储OSS Android SDK",
    developer: "阿里云计算有限公司",
    purpose: "文件上传下载和存储管理",
    policyUrl: "https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20240202100310511/20240202100310511.html",
    permissions: "对象存储OSS Android SDK用于实现文件上传下载和存储管理功能，需要收集基本设备信息(包括设备型号和操作系统信息)，用于改进应用使用体验。使用的设备权限主要包括：网络访问权限(android.permission.INTERNET，必选权限，用于发起网络访问请求，实现数据传输功能)，以及存储权限(android.permission.WRITE_EXTERNAL_STORAGE和android.permission.READ_EXTERNAL_STORAGE，可选权限，用于读取本地文件上传到对象存储、下载对象存储文件到本地，以及在断点续传时保存断点记录信息)。SDK内部集成了第三方组件Okhttp3(由Square, Inc提供)用于处理网络请求，但不会通过该组件收集或共享任何个人信息。",
  },
  {
    name: "微信OpenSDK Android",
    developer: "深圳市腾讯计算机系统有限公司",
    purpose: "微信分享、登录和支付",
    policyUrl: "https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8",
    permissions: "微信OpenSDK Android用于实现应用内与微信的功能对接，包括分享内容到微信、使用微信登录和微信支付等功能。SDK需要收集的信息包括：用户在第三方应用中主动选择分享的图片或内容(用于分享功能)、用户授权后的微信头像和昵称(用于登录功能)、支付订单标识和支付状态信息(用于支付功能)，以及在Android系统中验证设备上微信APP的安装状态。SDK需要使用的权限主要包括：网络访问权限(用于与微信服务器通信)和在iOS系统中的剪切板权限(用于实现应用间信息传输)。所有个人信息仅用于实现相关功能，不会用于关联和追踪用户，且存储于中国境内，仅保留必要时间。",
  },
  {
    name: "极光推送 SDK",
    developer: "深圳市和讯华谷信息技术有限公司",
    purpose: "信息推送服务",
    policyUrl: "https://www.jiguang.cn/",
    permissions: "设备标识符（包括Android ID、GAID、OAID、UAID、IDFA、AAID、Boot ID）、设备硬件信息（包括设备型号、设备屏幕分辨率、设备硬件制造商、设备产品名称、设备存储空间）、操作系统信息（包括操作系统版本、系统名称、系统语言）、网络信息（包括网络类型、运营商信息、IP地址、DHCP、WIFI状态信息）、推送信息日志：必要个人信息，用于推送服务基本业务功能场景中生成脱敏的终端用户设备唯一性标识。设备标识符（包括IMEI、MAC、IMSI）：可选个人信息。网络信息（包括SSID、BSSID、WIFI列表信息、基站信息、SIM卡状态）：可选个人信息。位置相关信息及软件列表信息为扩展功能所必要信息。数据处理方式：通过去标识化、加密传输及其他安全方式。",
  },
  {
    name: "科大讯飞 离线语音合成SDK",
    developer: "科大讯飞股份有限公司",
    purpose: "语音播报服务",
    policyUrl: "https://www.xfyun.cn/doc/tts/offline_tts/offline_tts_sdkprivacy.html",
    permissions: "获取权限：蓝牙权限、读写权限、网络权限、音频播放权限。收集个人信息类别：语音信息、文本信息、设备信息（设备号（IMEI号）、设备码（IMSI码）、IP地址、Android ID（安卓唯一设备ID以提供能力授权服务）、中国移动UAID（仅限安卓设备）、OAID（仅限安卓设备）、UUID（仅限iOS设备）、mac地址（仅限Linux设备））、日志信息。联系方式：dpo@iflytek.com",
  },
  {
    name: "腾讯地图SDK（Android）",
    developer: "深圳市腾讯计算机系统有限公司",
    purpose: "地图显示与定位服务",
    policyUrl: "https://privacy.qq.com/document/preview/a10a8634f237464da9a95f4f07e73e40",
    permissions: "腾讯地图SDK为了提供高质量的地图服务，需要收集并处理部分设备信息。在Android系统中，我们会收集网络类型（用于防止网络变化导致地图加载失败）、设备型号（确保SDK兼容不同手机厂商）、屏幕密度和尺寸（防止显示错误）、操作系统版本（避免系统接口差异导致崩溃）、IP地址（建立连接及问题处理）、OAID（用户定位和反作弊）、正在运行的进程名（排查崩溃问题）、SSID（提供地图服务）和SD卡信息（缓存地图数据节省流量）。所有信息通过HTTPS加密传输或仅本地使用不上传。必要系统权限包括网络访问(INTERNET)和网络状态检查(ACCESS_NETWORK_STATE)，可选权限为外部存储读写(WRITE_EXTERNAL_STORAGE)。",
  },
  {
    name: "腾讯定位SDK（Android）",
    developer: "深圳市腾讯计算机系统有限公司",
    purpose: "精确/粗略位置定位",
    policyUrl: "https://privacy.qq.com/document/preview/dbd484ce652c486cb6d7e43ef12cefb0",
    permissions: "腾讯定位SDK用于为用户提供精确或粗略的位置服务，在使用过程中需要收集设备相关信息。SDK会收集OAID(用于用户定位和反作弊)、系统属性和操作系统版本、系统设置、设备型号、运营商基站信息、WIFI信息(包括WiFi状态、参数、附近WiFi列表和已连接WiFi)、传感器信息(包括重力、陀螺仪、加速度、磁场和旋转矢量传感器)、蓝牙信息、精确位置信息(GPS)、BSSID、SSID、SIM卡状态、网络运营商名称及手机制式信息。所有信息均通过HTTPS加密传输。必要权限包括精确和粗略位置权限(ACCESS_FINE_LOCATION和ACCESS_COARSE_LOCATION)以及网络权限(INTERNET)。位置信息属于敏感个人信息。",
  },
  {
    name: "腾讯导航SDK（Android）",
    developer: "深圳市腾讯计算机系统有限公司",
    purpose: "路线规划和导航服务",
    policyUrl: "https://privacy.qq.com/document/preview/ba5687d1f4054fed8e108645255320f7",
    permissions: "腾讯导航SDK为提供精确定位、路线规划和导航服务，需要收集用户设备相关信息。SDK会收集网络类型、设备型号、操作系统版本、屏幕参数等基本设备信息；收集精确位置信息(GPS)、WIFI信息、基站信息、蓝牙信息等；收集传感器数据(包括重力、陀螺仪、加速度等)。所有收集的信息均通过HTTPS加密传输或仅本地使用。位置信息属于敏感个人信息。SDK还集成了腾讯智能平台TTS组件用于导航语音播报，该组件在本地处理数据不涉及个人信息上传。",
  },
];

const SdkListPage = (props) => {
  const company = props.tenant;
  const history = useHistory();

  return (
    <div className={styles.privacyPage}>
      <h1 className={styles.docTitle}>第三方SDK清单</h1>
      <p className={styles.docMeta}>共 {sdkList.length} 个SDK &nbsp;|&nbsp; 更新：2021年06月22日</p>

      <nav className={styles.pageNav}>
        <span className={styles.pageNavLink} onClick={() => history.push("/privacytext")}>完整版</span>
        <span className={styles.pageNavLink} onClick={() => history.push("/privacytext/simple")}>简易版</span>
        <span className={`${styles.pageNavLink} ${styles.active}`}>第三方SDK清单</span>
      </nav>

      <p className={styles.sdkIntro}>
        为保障"{company}"车主APP相关功能的实现与应用的稳定运行，我们可能会接入由第三方提供的软件开发包（SDK）以实现相关目的。关于第三方如何收集、使用您的个人信息，建议您参考第三方SDK的相关服务协议及个人信息保护政策。
      </p>

      {sdkList.map((sdk, i) => (
        <div key={i} className={styles.sdkItem}>
          <div className={styles.sdkName}>{sdk.name}</div>
          <div className={styles.sdkMeta}>
            <span>{sdk.developer}</span>
            <span>{sdk.purpose}</span>
          </div>
          <div className={styles.sdkPermissions}>{sdk.permissions}</div>
          <a
            className={styles.sdkPolicyLink}
            href={sdk.policyUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            查看隐私政策 &rsaquo;
          </a>
        </div>
      ))}

      <div className={styles.autoStartNotice}>
        <h2>自启动和关联启动说明</h2>
        <p>
          为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。
        </p>
      </div>

      <div className={styles.footer}>
        <div className={styles.footerLinks}>
          <a onClick={() => history.push("/privacytext")}>完整版隐私政策</a>
          <a onClick={() => history.push("/privacytext/simple")}>简易版</a>
          <a onClick={() => history.push("/service")}>服务协议</a>
        </div>
        <p>&copy; {new Date().getFullYear()} {company}</p>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(SdkListPage);
